export default __webpack_public_path__ + "static/media/img3.b555618e.webp";